import React from 'react'
import Breadcrumbs from './Breadcrumbs'
import { BreadcrumbsSchema } from 'client/fragments/listerFragment/components/SchemaOrg/BreadcrumbsSchema'
import { useSelector } from 'react-redux'

const ListerBreadcrumbs = ({ children, ...props }) => {
  const { breadcrumbs, target, t } = props
  const withBreadcrumbs = useSelector(it => it.data.withBreadcrumbs)

  return (
    <nav
      className='mxd-lister-breadcrumbs'
      style={{ gridArea: 'header', marginBottom: '1rem' }}
      data-testid='lister-breadcrumbs'
      aria-label='breadcrumb'
    >
      {breadcrumbs && withBreadcrumbs && (
        <>
          <BreadcrumbsSchema list={breadcrumbs.collection} />
          <Breadcrumbs list={breadcrumbs.collection} prefix={t('lister.breadcrumbs.prefix')} target={target} />
        </>
      )}
      {children}
    </nav>
  )
}

export default ListerBreadcrumbs
